import React, { Component } from 'react';
import { Dropdown, DropdownMenu, DropdownItem } from 'reactstrap';
import RenderComponents from './renderComponents.js';
import Firebase from 'firebase';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { withRouter} from 'react-router-dom';

class FormView extends Component {
    constructor() {
        super();
        this.state = {

        }
        this.DateToFormattedString = this.DateToFormattedString.bind(this);
        this.editForm = this.editForm.bind(this);
        this.getOptions = this.getOptions.bind(this);
    }

    componentWillMount() {
        var charts = this.state.chart;
        var formRef = Firebase.database().ref("forms")
            .child(this.props.match.params.formId)
            .once('value')
            .then(resp => {
                this.setState({ elements: resp.val().pages[0].elements, data: resp.val(), published: resp.val().published, count: Object.values(resp.val().pages)[0].elements.length })
            });
    }

    DateToFormattedString(d) {
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        return yyyy + '-' + (mm[1] ? mm : "0" + mm[0]) + '-' + (dd[1] ? dd : "0" + dd[0]);
    };

    getOptions() {
        var drafRef = Firebase.database().ref("draft").child(this.props.match.params.formId).once("value").then(resp => {
            if (resp.val()) {
                this.props.history.push("/editor/"+this.props.match.params.formId);
            } else {
                this.editForm();
            }
        })
    }

    editForm() {
        var drafRef = Firebase.database().ref("draft")
        var formRef = Firebase.database().ref('forms')
            .child(this.props.match.params.formId)
            .once('value')
            .then(resp => {
                var data = resp.val();
                drafRef.child(this.props.match.params.formId).set(
                    [data][0]
                ).then(resp => {
                    this.props.history.push("/editor/"+this.props.match.params.formId);
                });
            });
    }

    render() {
        var time;
        var fecha = "no disponible"
        let arrayElement = [];
        if (this.state.elements && this.state.data) {
            var time = new Date(this.state.data.modified_at);
            var fecha = this.DateToFormattedString(time);
            let prueba = this.state.elements;
            Object.keys(this.state.elements).map((e) => {
                arrayElement.push(this.state.elements[e]);
            })
            return (
                <div className="animated fadeIn" style={{ padding: "20px" }}>
                    <br />
                    <br />
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card card-outline-primary" style={{ marginTop: "2px" }}>
                                <div className="card-block pb-0">
                                    <div className="callout callout-success">
                                        <h4 >{this.state.data.name}</h4>
                                        <p><b>Versión: </b>{this.state.data.version}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card card-outline-primary">
                                <div className="card-block">
                                    <div className="col-md-12">
                                        <div className="form-group row">
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                <p><b>Ultima modificación: </b>{fecha}</p>
                                            </div>
                                            <div className="col-lg-12 col-md-12 col-sm-12">
                                                <a style={{ cursor: "pointer" }} onClick={() => { this.getOptions() }} id="edit" className="btn btn-outline-success"><i className="fa fa-pencil"></i> Editar</a>
                                                <Modal isOpen={this.state.showModal} style={{ backgroundColor: "rgba(255, 255, 255, 0)" }} toggle={() => { this.setState({ showModal: false }) }} className="modal-dialog modal-lg">
                                                    <ModalHeader>
                                                        Ya existe un borrador de éste formulario
                                                </ModalHeader>
                                                    <ModalBody>
                                                        ¿Desea restaurar el borrador existente o crear uno nuevo?
                                                </ModalBody>
                                                    <ModalFooter>
                                                        <button type="button" pullLeft style={{ cursor: "pointer" }} onClick={() => { }} id="edit" className="btn btn-outline-primary"><i className="fa fa-pencil"></i> Abri borrador</button>
                                                        <button type="button" pullRight style={{ cursor: "pointer" }} onClick={() => this.editForm()} id="edit" className="btn btn-outline-success"><i className="fa fa-pencil"></i> Crear nuevo</button>
                                                    </ModalFooter>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card card-outline-primary" style={{top: 1}}>
                                <div className="card-block">
                                    <div className="col-md-12">
                                        <div className="form-group row">
                                            <div className="col-md-6 text-center" onClick={() => this.setState({ visibility: "android" })}>
                                                <img src="/icons/smartphone2.svg" id="smartphone" style={{ width: "40%" }} /><br />Vista de Smartphone
                                        </div>
                                            <div className="col-md-6 text-center" onClick={() => this.setState({ visibility: "ipad" })}>
                                                <img src="/icons/ipad2.svg" id="ipad" style={{ width: "40%" }} /><br />Vista de Tablet
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6" style={this.state.visibility === "ipad" ?
                            {
                                borderColor: "#263238", margin: "auto", borderStyle: "solid", borderRadius: "30px",
                                borderBottomWidth: "30px", borderTopWidth: "30px", borderLeftWidth: "15px",
                                borderRightWidth: "15px", maxWidth: "550px", height: "875px", backgroundColor: "white"
                            }
                            :
                            {
                                borderColor: "#263238", margin: "auto", borderStyle: "solid", borderRadius: "30px",
                                borderLeftWidth: "10px", borderRightWidth: "10px", borderBottomWidth: "60px",
                                borderTopWidth: "60px", maxWidth: "400px"
                            }}>
                            <div style={this.state.visibility === "ipad" ? { padding: "10px", maxHeight: "815px", width: "520px", marginLeft: "-15px", overflowY: "auto", backgroundColor: "white", height: "815px" } : { maxHeight: "700px", width: "380px", marginLeft: "-15px", overflow: "auto", backgroundColor: "white", height: "700px" }}
                            >

                                {
                                    arrayElement.map((e, key) => (
                                        <div className="card text-center" key={key} style={{ marginBottom: "0", paddingBottom: "5px", borderColor: "white" }}>
                                            <RenderComponents element={e} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="col-md-3">
                            {/* <div className="card card-inverse card-primary">
                            <div className="card-block pb-0">
                                <div className="btn-group float-right">
                                    <Dropdown isOpen={this.state.card1} toggle={() => { this.setState({ card1: !this.state.card1 }); }} >
                                        <button onClick={() => { this.setState({ card1: !this.state.card1 }); }} className="btn btn-transparent active dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.card1}>
                                            <i className="icon-settings"></i>
                                        </button>
                                        <DropdownMenu>
                                            <DropdownItem>Action</DropdownItem>
                                            <DropdownItem>Another action</DropdownItem>
                                            <DropdownItem>Something else here</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                                <h4 className="mb-0">{this.state.countReg}</h4>
                                <p>Registros</p>
                                <BarChart data={this.state.chart} options={this.state.options} width="270" />
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div >
            );
        } else {
            return (
                <div>
                </div>
            )
        }
    }
}
export default FormView;



// WEBPACK FOOTER //
// ./src/views/forms/FormView.js